import '@radix-ui/themes/styles.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Theme } from '@radix-ui/themes';

import App from './App.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Theme hasBackground={false} accentColor="mint" grayColor="sage">
      <App />
    </Theme>
  </StrictMode>
);
